"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Singleton = exports.BrandNameHelper = exports.EBrand = exports.CaseModifier = void 0;
var environment_helper_1 = require("./environment.helper");
var CaseModifier;
(function (CaseModifier) {
    CaseModifier[CaseModifier["PASCAL_CASE"] = 0] = "PASCAL_CASE";
    CaseModifier[CaseModifier["LOWER_CASE"] = 1] = "LOWER_CASE";
    CaseModifier[CaseModifier["UPPER_CASE"] = 2] = "UPPER_CASE";
})(CaseModifier = exports.CaseModifier || (exports.CaseModifier = {}));
var EBrand;
(function (EBrand) {
    EBrand["UNIPOL"] = "Unipol";
    EBrand["UNIPOLSAI"] = "UnipolSai";
})(EBrand = exports.EBrand || (exports.EBrand = {}));
exports.BrandNameHelper = {
    /**
     * Ritorna il nome del brand
     * @param modifier
     */
    brandName: function (modifier) {
        if (modifier === void 0) { modifier = CaseModifier.PASCAL_CASE; }
        var brandName = Singleton.getInstance().names.brandName;
        // Modifico la stringa in modo da adattarsi ai vari casi
        switch (modifier) {
            case CaseModifier.PASCAL_CASE:
                return brandName;
            case CaseModifier.LOWER_CASE:
                return brandName.toLowerCase();
            case CaseModifier.UPPER_CASE:
                return brandName.toUpperCase();
            default:
                return brandName;
        }
    },
    urlName: function () {
        return Singleton.getInstance().names.urlName;
    },
    brand: function () {
        return Singleton.getInstance().names.brand;
    },
    pec: function () {
        return Singleton.getInstance().names.pec;
    }
};
var Singleton = /** @class */ (function () {
    // Il costruttore è privato per evitare la creazione di istanze al di fuori della classe
    function Singleton() {
        // Inizializzazione qui
        this.names = this.setupBrandNames();
    }
    // Metodo statico per ottenere l'istanza unica
    Singleton.getInstance = function () {
        if (!Singleton.instance) {
            Singleton.instance = new Singleton();
        }
        return Singleton.instance;
    };
    Singleton.prototype.setupBrandNames = function () {
        // Utilizza la funzione isAfterMidnight2025 per determinare l'anno
        var isAfterMidnight2025 = this.isRebrandingActive();
        var brandName = isAfterMidnight2025 ? 'Unipol' : 'UnipolSai';
        var urlName = isAfterMidnight2025 ? 'unipol' : 'unipolsai';
        var brand = isAfterMidnight2025 ? EBrand.UNIPOL : EBrand.UNIPOLSAI;
        var pec = isAfterMidnight2025 ? 'unipol' : 'unipolsaiassicurazioni';
        return { brandName: brandName, urlName: urlName, brand: brand, pec: pec };
    };
    Singleton.prototype.isRebrandingActive = function () {
        // Se il timestamp non è fornito, utilizza la data corrente
        console.log('[BrandNameHelper - isAfterMidnight2025] DEPLOY_ENV_NAME', process.env.DEPLOY_ENV_NAME);
        if (environment_helper_1.EnvironmentHelper.isClientSide()) {
            var host = window.location.host;
            switch (host) {
                case 'dev.unipol.it':
                    console.log('[BrandNameHelper - isAfterMidnight2025] CS DEPLOY_ENV_NAME development case');
                    return true;
                case 'sit.unipol.it':
                    console.log('[BrandNameHelper - isAfterMidnight2025] CS DEPLOY_ENV_NAME integration case');
                    return true;
                case 'qa.unipol.it':
                    console.log('[BrandNameHelper - isAfterMidnight2025] CS DEPLOY_ENV_NAME quality case');
                    return true;
                default:
                    console.log('[BrandNameHelper - isAfterMidnight2025] CS DEPLOY_ENV_NAME default case');
                    //TODO Change to true before hotfix preparation for prod release rebranding(31/12)
                    return true;
            }
        }
        else {
            //TODO Change to true before hotfix preparation for prod rebranding (31/12)
            return true;
        }
    };
    // TODO: Rebranding 2025
    /**
     * names => {brandName: "UnipolSai", urlName: "unipolsai", brand: EBrand.UNIPOLSAI}
     * names => {brandName: "Unipol", urlName: "unipol", brand: EBrand.UNIPOL}
     * @param names
     */
    Singleton.prototype.setNames = function (names) {
        this.names = names;
    };
    Singleton.prototype.revalidateNames = function () {
        this.names = this.setupBrandNames();
    };
    return Singleton;
}());
exports.Singleton = Singleton;
